import React, { Fragment } from 'react';
import Linklist from '../../platformui/Linklist';

const FindCareLinks = (props) => {
  return (
    <Fragment>
      <Linklist
        Heading={props.Translations.title}
        Links={props.Items}
        className={'find-care-links'}
      >
        <a className="find-care-links__search" href={props.FindCarePageUrl}>
          <span>{props.Translations.linktext}</span>
        </a>
      </Linklist>
    </Fragment>
  );
};

export default FindCareLinks;
